
import { AuthService } from "../../services/auth-service";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import { isStringEmail } from "../../utils/strings";
import AppChangeProfilePicture from "./ChangeProfilePicture.vue";

export default FormLike.extend({
	data(){
		return {
			changeProfilePictureModal: false,
			originalEmail: AuthService.wfUser.Email,
			inputs: {
				firstName: AuthService.wfUser.Firstname,
				lastName: AuthService.wfUser.Lastname,
				userName: AuthService.wfUser.Username,
				phone: AuthService.wfUser.Phone,
				email: AuthService.wfUser.Email
			},
			AuthService
		};
	},
	computed: {
		isOwner():boolean {
			return AuthService.wfCompany.OwnerID == AuthService.wfUser.ID;
		},
		isEmailRequired():boolean{
			return AuthService.wfCompany.WorkspaceURL != "" || this.isOwner;
		},
		isEmailChanged():boolean {
			return this.originalEmail != this.inputs.email;
		},
		profileImgUrl():string{
			return this.AuthService.wfUser.getProfileImgUrl();
		},
		emailNotActivated():boolean {
			return this.AuthService.wfUser.Activated == false;
		}
	},
	methods: {
		async submit(){
			if (!this.isValid) return;
			let result = await AuthService.updateProfileInfo(this.inputs.firstName, this.inputs.lastName, this.inputs.userName, this.inputs.phone, this.inputs.email);
			if (this.isEmailChanged) {
				await this.$wf.dialog(this.$ct("messages.email-changed", {newEmail: this.inputs.email}), this.$ct("common.ok"), this.$ct("common.info"));
			}
			this.inputs.firstName = result.Firstname;
			this.inputs.lastName = result.Lastname;
			this.inputs.userName = result.Username;
			this.inputs.phone = result.Phone;
			this.inputs.email = result.Email;
		},
		isValidEmail():boolean {
			if (!this.isEmailRequired && this.inputs.email == ""){
				return true;
			}
			return isStringEmail(this.inputs.email);
		},
		async logout(){
			await AuthService.logout();
		},
		async verifyEmailClicked(){
			await AuthService.resendActivationEmail();
			let text = this.$ct("a-mail-has-been-sent-to-your-email-address-({email})-check-your-inbox-and-click-on-the-link", {email: AuthService.wfUser.Email});
			this.$wf.dialog(text, this.$ct("common.Ok"), this.$ct("activation-email-sent"));
		},
		async deleteProfilePicture(){
			await AuthService.deleteProfileImg();
		}
	},
	mounted(){
		this.validate();
		this.validators = [this.isValidEmail];
	},
	i18nEx: {
		componentPrefix: "components.account"
	},
	components: {
		AppChangeProfilePicture
	}
});
